import { render, staticRenderFns } from "./ConfirmDownload.vue?vue&type=template&id=4808f51c&scoped=true"
import script from "./ConfirmDownload.vue?vue&type=script&lang=js"
export * from "./ConfirmDownload.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDownload.vue?vue&type=style&index=0&id=4808f51c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4808f51c",
  null
  
)

export default component.exports